import React from "react";
import PropTypes from 'prop-types';
import { Button, Modal, Typography, Row, Space } from "antd";
import Box from "ui-box"
import { useTranslation } from "react-i18next";
import { ReactComponent as InfoCircleSvg } from '../../../assets/icons/medical-history/info-circle.svg';

const { Title, Paragraph } = Typography

const styles = {
  buttonPatient: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "22px",
    color: "#FA8C16",
    background: "#FFF7E6",
    border: "1px solid #FFD591",
    boxSizing: "border-box",
    borderRadius: "2px"
  },
  buttonDoctor: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "22px",
    color: "#52C41A",
    background: "#F6FFED",
    border: "1px solid #B7EB8F",
    boxSizing: "border-box",
    borderRadius: "2px"
  },
  info: {
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
    textAlign: "center",
    color: "#15A9E1",
    margin: 0
  },
}

function MedicalHistoryModal({ visible, onCancel }) {
  const { t } = useTranslation(['medical-history']);
  return (
    <Modal
      visible={visible}
      footer={null}
      onCancel={onCancel}
      style={{
          paddingRight: '15px',
          paddingLeft: '15px',
      }}
      closable
      centered
      width={480}
    >
      <Row justify="center" align="middle" style={{ marginBottom: 4 }}>
        <InfoCircleSvg style={{ marginRight: 5 }}/>
        <Title level={4} style={styles.info}>
          {t('medical-history:home.howWork')}
        </Title>
      </Row>
      <Box padding="10px" marginBottom={16}>
        <Paragraph>{t('medical-history:home.paragraphModal')}</Paragraph>
      </Box>
      <Space direction="vertical" style={{ width: '100%' }}>
        <Button
          onClick={() => {
            onCancel();
          }}
          style={styles.buttonPatient}
          type="primary"
          block
        >
          {t('medical-history:home.itemAddedPatient')}
        </Button>
        <Button
          onClick={() => {
            onCancel();
          }}
          style={styles.buttonDoctor}
          type="primary"
          block
        >
          {t('medical-history:home.itemAddedDoctor')}
        </Button>
      </Space>
    </Modal>
  );
}

MedicalHistoryModal.defaultProps = {
    visible: false,
    onCancel: () => null
};

MedicalHistoryModal.propTypes = {
    visible: PropTypes.bool,
    onCancel: PropTypes.func
};

export default MedicalHistoryModal;
